import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Row, Col, Form, AutoComplete, Input, Select, Upload, message, Spin, Drawer, Space, DatePicker, Modal, Table, Typography } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import "moment-timezone";
import ImgCrop from 'antd-img-crop';
import { Scrollbars } from 'react-custom-scrollbars';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Link, useHistory } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import InitialData from './InitialData.json'
import DetailsPage from './DetailsPage/Detailspage';
import LeadFields from './DetailsPage/LeadDetailsFields'
import RelatedTab from './DetailsPage/RelatedTab'
import LeadRightData from './DetailsPage/LeadRightData'
import LeadStatusBar from './DetailsPage/LeadStatusBar'
import AddTaskPage from './AddTask'
import { UploadUserTag } from './GlobalComponents/UserCardCmnts'
import { RelatedDocUpload } from './GlobalComponents/RelatedDocUpload'
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { hunterioLeadDetails } from '../../../Api/Services/CompanyApiService'
import { getStateData, getCityData, getAllUsersData, getRating, getAnnualRevenue, IndustryData, getNoofEmployee, getLeadsourceData, getSeniorityLevelData, getLeadStatusData, getCountryData, getTitle } from '../../../Api/Services/CommonApiService'
import { LeadDetailData, LeadSave, LeadUpdate, FetchAllLead } from '../../../Api/Services/LeadApiServices';
import { FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { useNavigationDecrypted, useExcryptedNavigation } from '../Filters/FilterConditions';
import { Main, BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import { getBaseURL } from '../../../Api/ApiConfig'
import ConvertPopup from "../Popup/LEMassPopup"
import NotesPopup from '../Popup/NotesPopup'
import CallLogPopup from '../Popup/CallLogPopup'
import AllCancelPopup from '../Popup/AllCancelPopup';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import Approvaldialog from '../Popup/Approvaldialog'
import ComposeMail from '../Email/Compose';
import MeetingLiPopup from '../Popup/MeetingLiPopup'
import MergePage from '../Popup/MergePage'
import SharePopup from '../Popup/SharePopup'
import AddtoCampaignPopup from '../Popup/AddtoCampaignPopup'
import AddtoOutreachPopup from '../Popup/AddtoOutreachPopup'
import { CalendarIcon, CloneIcon, EditIcon, ShareIcon, CancelIcon, QUSOINIcon, DeleteIcon, SaveIcon, ChangeOwnerIcon, MergeIcon, ConvertIcon, EmailIcon, TaskIcon, NotesIcon, CallLogIcon, CampaignIcon, EmailseqQueueIcon } from '../../../components/Icons/Icons';
import { mobileOnChangeValidator, nameOnChangeValidator, validateZipCode, validateUrlField, validateEmailField, validateDescriptionField, validateAddressLine } from '../../../components/utilities/utilities';
// import { mobileOnChangeValidator, nameOnChangeValidator, validateZipCode, validateTextField, validateUrlField, validateEmailField, validateDescriptionField, validateAddressLine } from '../../../components/utilities/utilities';

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, ShortCut }) {
    const loadingRef = useRef(false);
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const dispatch = useDispatch();
    const history = useHistory();
    const [form] = Form.useForm();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const [editField, setEditField] = useState(false)
    const [doubleClick, setDoubleClick] = useState(false)
    const [deleteClick, setDelteClick] = useState(false)
    const permission = localData.permissions
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
    const tz = extractTimeZoneName(tzString);
    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
    const currentDate = new Date(currentrealTime);
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    const hours = String(currentDate.getHours()).padStart(2, '0');
    const minutes = String(currentDate.getMinutes()).padStart(2, '0');
    const formattedTime = `${hours}:${minutes}`;
    const [trigger, setTrigger] = useState()
    const [leadInitial, setLeadInitial] = useState()
    const [relatedLead, setRelatedLead] = useState()
    const [edit, setEdit] = useState(false)
    const [approveOpen, setApproveOpen] = useState(false)
    const [leadId, setLeadId] = useState()
    const [displayData, setDisplayData] = useState()
    const [country, setCountry] = useState()
    const [allCountry, setAllCountry] = useState([])
    const [state, setState] = useState()
    const [allState, setAllState] = useState([])
    const [city, setCity] = useState()
    const [allCity, setAllCity] = useState([])
    const [checked, setChecked] = useState(false)
    const [image, setImage] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [leadStatus, setLeadStatus] = useState([])
    const [leadStatusData, setLeadStatusData] = useState([])
    const [seniority, setSeniority] = useState([])
    const [leadsource, setLeadSource] = useState([])
    const [users, setUsers] = useState([])
    const [industryData, setIndustryData] = useState([])
    const [FILEList, setFileList] = useState([]);
    const [popup, setPopup] = useState(false)
    const [values, setValues] = useState()
    const [deleteOption, setDeleteOpen] = useState(false);
    const [campaignPopup, setCampaignPopup] = useState(false)
    const [outreachPopup, setOutreachPopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [action, setAction] = useState()
    const [assignOwner, setAssignOwner] = useState()
    const [notePopup, setNotePopup] = useState(false)
    const [callLogPopup, setCallLogPopup] = useState(false)
    const [NacTrigger, setNaCTrigger] = useState()
    const [page, setPage] = useState()
    const [mailOpen, setMailOpen] = useState(false)
    const [taskProp, setTaskProp] = useState()
    const [taskPage] = useState("AddPage")
    const [dataDisables, setDataDisables] = useState({
        isDisable: false,
        allow: false,
        id: null,
        profile: null
    })
    const [drawerPage, setDrawerPage] = useState()
    const [pages] = useState("Meeting")
    const [dataPermissions, setDataPermissions] = useState()
    const [createPageTask, setCreatePageTask] = useState()
    const [popupMessage, setPopupMessage] = useState(false)
    const [meetingOpen, setMeetingOpen] = useState(false)
    const [account, setAccount] = useState([])
    const [rating, SetRating] = useState([])
    const [title, setTitle] = useState([])
    const [noofemployee, setNoofemployee] = useState([])
    const [revenue, setRevenue] = useState([])
    console.log(title, "title", industryData, rating, noofemployee, revenue)
    const [sharePopup, setSharePopup] = useState(false)
    const [mergeOpen, setMergeOpen] = useState(false)
    const [approveCondition, setApproveCondition] = useState(false)
    const [meetingAttendees, setMeetingAttendees] = useState([])
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [permissions] = useState(permission.entity)
    const [expectedClosureDate, setExpectedClosureDate] = useState(null)
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const PageCancel = () => {
        history.push('/Home/candidates')
    }
    // Create
    const canCreate = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        return hasRolePermission;
    };
    // Share
    const canShare = (dataPermissions, action) => {
        if (!dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasDataPermission;
    };
    // Update/Delete
    const hasRoleDeletePermission = (rolePermissions, actionRoleId) => {
        if (!Array.isArray(rolePermissions)) return false;
        return rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
    };
    const canUpdateDelete = (rolePermissions, dataPermissions, action, actionRoleId) => {
        if (!Array.isArray(rolePermissions) || !dataPermissions) return false;
        const normalizedDataPermissions = dataPermissions.split(",").map((p) => p.trim().toLowerCase());
        const hasRolePermission = rolePermissions.includes(actionRoleId) || rolePermissions.includes("*");
        const hasDataPermission = normalizedDataPermissions.includes(action.toLowerCase());
        return hasRolePermission && hasDataPermission;
    };
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    const successMessage = (titles, data, type) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    {type === "Approve" ? <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} /> : <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />}
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => {
                modal.destroy();
                if (type === "Approve") {
                    setTimeout(() => {
                        history.push('/Home/candidates')
                        // getData(leadId); // This runs after 2 seconds
                    }, 1000);
                }
            }
        });
    }
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };
    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const getCity = async (Address, isoCode) => {
        try {
            const response = await getCityData(isoCode)
            setAllCity(response);
            if (Address.city) {
                setCity(Address.city)
            } else {
                setCity(null)
            }
        } catch (error) {
            message.error(error)
        }
    }
    const getState = async (Address, option) => {
        try {
            const response = await getStateData(option)
            setAllState(response);
            if (Address.state) {
                setState(Address.state)
                const stateinfo = response.find(states => states.state === Address.state);
                if (stateinfo) {
                    const iso = stateinfo.stateId
                    getCity(Address, iso)
                }
            } else {
                setState(null)
            }
        } catch (error) {
            message.error(error)
        }
    }
    const onnavigate = () => {
        history.push("/Home/email-config")
    }
    async function fetchLeadAndAccount() {
        try {
            // Run both requests in parallel
            const [leads, accounts] = await Promise.all([
                FetchAllLead(),
                FetchAllAccount()
            ]);

            return { leads, accounts };
        } catch (error) {
            message.error(error);
            throw error; // rethrow so caller knows it failed
        }
    }
    function getLatestLeads(leads) {
        const result = leads.reduce((acc, lead) => {
            const key = lead.account_name;
            if (!acc[key]) {
                acc[key] = lead;
                return acc;
            }
            const currentDT =
                (lead.modified_at || "")
                    .split("-").join("") +
                (lead.modified_time || "")
                    .split(":").join("");
            const existing = acc[key];
            const existingDT =
                (existing.modified_at || "")
                    .split("-").join("") +
                (existing.modified_time || "")
                    .split(":").join("");
            if (currentDT > existingDT) {
                acc[key] = lead;
            }
            return acc;
        }, {});
        return Object.values(result);
    }
    async function AccountApi() {
        try {
            const { leads, accounts } = await fetchLeadAndAccount();
            const latestLeads = getLatestLeads(leads);
            const leadAccounts = latestLeads.map(item => ({
                value: item.account_name,
                key: item.account_name,
                data: { status: "Not Qualified", accountID: null, accountProfile: null, industry: item.industry, rating: item.rating, employee: item.nom_of_employees, revenue: item.annual_revenue, website: item.website, leadId: item.leads_id }
            }));
            const apiAccounts = accounts.map(item => ({
                value: item.account_name,
                key: item.account_name,
                data: { status: "Qualified", accountID: item.account_id, accountProfile: item.account_profile, industry: item.industry, rating: item.rating, employee: item.nom_of_employees, revenue: item.annual_revenue, website: item.website, leadId: null }
            }));
            const mergedAccounts = Array.from(
                new Map(
                    [...leadAccounts, ...apiAccounts].map(item => [item.value, item])
                ).values()
            );
            setAccount(mergedAccounts);
        }
        catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId}
                    label={(
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                        < img src={option.profilePic} alt="profile" />
                                        :
                                        <span className="image_icon UserIcon">
                                            {option.firstName.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                </div>
                            </div>
                        </div>
                    )}
                    key={i}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function IndustryDataApi() {
        try {
            const data = await IndustryData()
            setIndustryData(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getAnnualRevenueData = async () => {
        try {
            const data = await getAnnualRevenue()
            const options = data.map((option, i) => (
                <Option value={option.annualRevenue} key={i}>
                    {option.annualRevenue}
                </Option>));
            setRevenue(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getRatingData = async () => {
        try {
            const data = await getRating()
            const options = data.map((option, i) => (
                <Option value={option.rating} key={i}>
                    {option.rating}
                </Option>));
            SetRating(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getNomEmployeeData = async () => {
        try {
            const data = await getNoofEmployee()
            const options = data.map((option, i) => (
                <Option value={option.nomOfEmployee} key={i}>
                    {option.nomOfEmployee}
                </Option>));
            setNoofemployee(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getTitleData = async () => {
        try {
            const data = await getTitle()
            const options = data.map((option, i) => (
                <Option value={option.title} key={i}>
                    {option.title}
                </Option>));
            setTitle(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getLeadsource = async () => {
        try {
            const data = await getLeadsourceData()
            const options = data.map((option, i) => (
                <Option value={option.leadSourceId} key={i}>
                    {option.leadSourceName}
                </Option>));
            setLeadSource(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getLeadStatus = async () => {
        try {
            const data = await getLeadStatusData()
            const options = data.map((option, i) => (
                <Option value={option.leadStatusId} key={i}>
                    {option.leadStatusName}
                </Option>));
            setLeadStatus(options)
            setLeadStatusData(data)
            if (UrlId === undefined) {
                const Datas = data.find(option => option.leadStatusName === "Not Contacted")?.leadStatusId
                form.setFieldsValue({ leadStatus: Datas })
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    const getSeniorityLevel = async () => {
        try {
            const data = await getSeniorityLevelData()
            setSeniority(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
            if (displayData.country) {
                const countryInfo = response.find(countrys => countrys.country === displayData.country);
                if (countryInfo) {
                    const iso = countryInfo.countryId
                    getState(displayData, iso)
                }
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    async function setInitialData(value) {
        setLeadInitial({
            seniorityLevelId: normalizeValue(value.seniority_level_id),
            firstName: normalizeValue(value.first_name),
            lastName: normalizeValue(value.last_name),
            leadOwner: normalizeValue(value.lead_owner),
            designation: normalizeValue(value.designation),
            accountName: normalizeValue(value.account_name),
            industry: normalizeValue(value.industry),
            rating: normalizeValue(value.rating),
            nomOfEmployees: normalizeValue(value.nom_of_employees),
            title: normalizeValue(value.title),
            primaryEmail: normalizeValue(value.primary_email),
            secondaryEmail: normalizeValue(value.secondary_email),
            phone: normalizeValue(value.phone),
            mobile: normalizeValue(value.mobile),
            leadSourceId: normalizeValue(value.lead_source_id),
            leadStatusId: normalizeValue(value.lead_status_id),
            emailOptOut: normalizeValue(value.email_opt_out === 1 || value.email_opt_out === true),
            fax: normalizeValue(value.fax),
            description: normalizeValue(value.description),
            leadProfile: normalizeValue(value.lead_profile),
            leadFiles: (value.lead_files || []),
            city: normalizeValue(value.city),
            street: normalizeValue(value.street),
            country: normalizeValue(value.country),
            postcode: normalizeValue(value.postcode),
            state: normalizeValue(value.state),
            annualRevenue: normalizeValue(value.annual_revenue),
            website: normalizeValue(value.website),
            linkedinUrl: normalizeValue(value.linkedin_url),
            relatedLeadId: normalizeValue(value.related_lead_id)
        })
    }
    const setData = async (value) => {
        if (value !== undefined) {
            if (drawerPage !== "CloneLead") {
                if (value.approved_for !== "None") {
                    setApproveOpen(true)
                    setApproveCondition(true)
                }
                else {
                    setApproveOpen(false)
                    setApproveCondition(false)
                }
            }
            setAssignOwner(value.lead_owner)
            form.setFieldsValue({
                firstName: value.first_name,
                lastName: value.last_name,
                leadOwner: value.lead_owner,
                description: value.description,
                postcode: (value.postcode === "0" || value.postcode === 0) ? null : value.postcode,
                street: value.street,
                accountName: value.account_name,
                secondaryEmail: value.secondary_email,
                leadStatus: value.lead_status_id,
                leadSource: value.lead_source_id,
                mobile: (value.mobile === "0" || value.mobile === 0) ? null : value.mobile,
                fax: value.fax,
                phone: (value.phone === "0" || value.phone === 0) ? null : value.phone,
                primaryEmail: value.primary_email,
                title: value.title,
                designation: (value.designation !== "" && value.designation !== null && value.designation !== "Not Applicable") ?
                    moment(formatDateString(value.designation, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                    : null,
                annualrevenue: value.annual_revenue,
                noofemployees: value.nom_of_employees,
                industry: value.industry,
                rating: value.rating,
                seniorityLevel: value.seniority_level_id,
                country: value.country,
                websiteName: value.website,
                linkedinUrl: value.linkedin_url,
            })
            setExpectedClosureDate((value.designation !== "" && value.designation !== null && value.designation !== "Not Applicable") ? value.designation : null)
            setRelatedLead(value.related_lead_id)
            setFileList(value.lead_files || [])
            setImage(value.lead_profile)
            setDeleteOpen(value.lead_profile && value.lead_profile !== "")
            setChecked(value.email_opt_out === 1 || value.email_opt_out === true)
            setLeadId(value.leads_id)
            setStates({
                ...states,
                selectedRowKeys: [value.leads_id]
            });
            setCountry(value.country)
        }
    }
    async function deleteMenu(id) {
        setValues([id])
        setPopup(true)
        setPopupType("Delete")
        setAction("DeleteNav")
    }
    async function ConvertApi(id) {
        setValues([id])
        setPopup(true)
        setPopupType("Convert")
        setAction("ConvertNav")
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);

        return formattedDate
    }
    async function getSharingPermissions(id) {
        if (id) {
            setDataPermissions(id)
        }
        else {
            setDataPermissions("Read,Update,Delete,Sharing")
        }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        setApproveOpen(false)
        setApproveCondition(false)
        setAssignOwner(null)
        form.setFieldsValue({
            firstName: null,
            lastName: null,
            leadOwner: null,
            description: null,
            postcode: null,
            street: null,
            accountName: null,
            secondaryEmail: null,
            leadStatus: null,
            leadSource: null,
            mobile: null,
            fax: null,
            phone: null,
            primaryEmail: null,
            title: null,
            designation: null,
            annualrevenue: null,
            websiteName: null,
            noofemployees: null,
            industry: null,
            rating: null,
            seniorityLevel: null,
            country: null,
            linkedinUrl: null,
        })
        setExpectedClosureDate(null)
        setFileList([])
        setImage()
        setDeleteOpen()
        setChecked(false)
        setStates({
            ...states,
            selectedRowKeys: []
        });
        setDrawerPage()
        setCountry()
        setState()
        setCity()
        if (FromPage !== "EntityUpdate" && ShortCut !== "Shortcut") {
            GetAll();
            setCratePage();
        }
        if (ShortCut === "Shortcut") {
            setCratePage()
        }
        if (drawerPage === "CloneLead" || ShortCut === "Shortcut") {
            PageCancel()
        }
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
        setUiReady(false)
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setDrawerPage()
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    async function getData(leadId) {
        try {
            if (drawerPage === "CloneLead") {
                const responseData = await LeadDetailData(leadId);
                const response = responseData.data
                getSharingPermissions(undefined)
                setData(response);
                setLeadInitial(InitialData.LeadData)
                const transformedItem = {
                    ...response,
                    created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                    modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
                };
                setDisplayData(transformedItem)
            } else {
                const responseData = await LeadDetailData(leadId);
                if (!responseData.allow) throw new Error();
                const response = responseData.data
                getSharingPermissions(response?.sharingPermission?.sharePermission)

                setData(response);
                setInitialData(response)
                const transformedItem = {
                    ...response,
                    created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                    modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
                };
                setDisplayData(transformedItem)
            }
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function getData1(leadId, hideMessage, isAutomation, updateResponse) {
        try {
            const responseData = await LeadDetailData(leadId);
            hideMessage();
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Lead <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            if (!responseData.allow) throw new Error();
            const response = responseData.data
            getSharingPermissions(response?.sharingPermission?.sharePermission)
            setData(response);
            setInitialData(response)
            const transformedItem = {
                ...response,
                created_at: response.created_at ? convertAndFormatDateTime(response.created_time ? `${response.created_at} ${response.created_time}` : response.created_at, companyProfile, profile) : "",
                modified_at: response.modified_at ? convertAndFormatDateTime(response.modified_time ? `${response.modified_at} ${response.modified_time}` : response.modified_at, companyProfile, profile) : "",
            };
            setDisplayData(transformedItem)
            setTrigger("activity")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
        } catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Lead <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted();
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                setLeadId(response)
                dataFound = true;
                getData(response)
            }
            else {
                dataFound = false;
            }
        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const handleCountryChange = async (value, option) => {
        setCountry(value);
        if (option.key) {
            try {
                const response = await getStateData(option.key)
                setAllState(response);
                setState()
                setCity()
                setAllCity([])
            } catch (error) {
                message.error(error)
            }
        } else {
            setAllState([]);
            setAllCity([])
            setState()
            setCity()
        }
    }
    const handleStateChange = async (value, option) => {
        setState(value);
        if (option.key) {
            try {
                const response = await getCityData(option.key)
                setAllCity(response);
                setCity()
            } catch (error) {
                message.error(error)
            }
        }
        else {
            setAllCity([]);
            setCity()
        }
    }
    const handleCityChange = (value) => {
        setCity(value)
    }
    // const handleChange = (value) => {
    //     setChecked(value)
    // }
    useEffect(() => {
        if (FromPage) {
            scroolup();
            getLeadStatus()
        }
    }, [FromPage])
    const fetchAll = async () => {
        await Promise.allSettled([
            getCountry(),
            getRatingData(),
            getAnnualRevenueData(),
            getNomEmployeeData(),
            getTitleData(),
            UserDetailsApi(),
            getLeadsource(),
            getSeniorityLevel(),
            AccountApi(),
            IndustryDataApi(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll()
        }
    }, [FromPage, editField, displayData])
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const handleNoteClick = (value) => {
        setNotePopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
        setPage("Entity")
    }
    const handleCallLogClick = (value) => {
        setCallLogPopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
    }
    const AssignToFucntion = () => {
        if (approveCondition) { setApproveOpen(true) }
        else {
            setValues([leadId])
            setPopup(true)
            setPopupType("Change Owner")
            setAction("SingleChangeOwner")
        }
    }
    const HandleAddCampaignClick = () => {
        setCampaignPopup(true)
    }
    const HandleAddOutreachClick = () => {
        setOutreachPopup(true)
    }
    const HandleShareClick = () => {
        setSharePopup(true)
    }
    const CloneLead = () => {
        setDrawerPage("CloneLead")
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Sales") {
                form.setFieldsValue({
                    leadOwner: profile.userId
                });
            }
        }
    }
    useEffect(() => {
        const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
        const currentFromPage = FromPage;
        const isCloneLead = drawerPage === "CloneLead";
        if (
            !isCloneLead &&
            prevValues.current.UrlId === currentUrlId &&
            prevValues.current.FromPage === currentFromPage
        ) {
            return;
        }
        prevValues.current = {
            UrlId: currentUrlId,
            FromPage: currentFromPage,
        };
        if (FromPage) {
            if (FromPage === "EntityUpdate") {
                if (drawerPage === "CloneLead") {
                    getData(leadId)
                    setDataPermissions("Read,Update,Delete,Sharing")
                    setEditField(true)
                    setEdit(true)
                }
                else {
                    getEntityAvalibitlity()
                }
            }
            else {
                form.setFieldsValue({
                    firstName: undefined,
                    lastName: undefined,
                    leadOwner: undefined,
                    description: undefined,
                    postcode: undefined,
                    street: undefined,
                    accountName: undefined,
                    secondaryEmail: undefined,
                    leadStatus: undefined,
                    leadSource: undefined,
                    mobile: undefined,
                    fax: undefined,
                    phone: undefined,
                    primaryEmail: undefined,
                    title: "Mr.",
                    designation: undefined,
                    annualrevenue: undefined,
                    websiteName: undefined,
                    noofemployees: undefined,
                    industry: undefined,
                    rating: undefined,
                    seniorityLevel: undefined,
                    country: undefined,
                    linkedinUrl: undefined,
                })
                setExpectedClosureDate(null)
                setFileList([])
                setImage()
                setDeleteOpen()
                setChecked(false)
                setLeadId()
                setStates({
                    ...states,
                    selectedRowKeys: []
                });
                setCountry()
                setState()
                setCity()
                getUserDetail()
                setDisplayData("Create")
                setRelatedLead()
                setLeadInitial(InitialData.LeadData)
                setDataPermissions("Read,Update,Delete,Sharing")
                setEdit(true)
                setEditField(true)
            }
        }
    }, [UrlId, FromPage, drawerPage]);
    const FileUpload = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: 'image/*',
        action: `${getBaseURL()}/usermgmt/uploadFile`,
        onChange(info) {
            const { status } = info.file;
            if (status === 'done') {
                setImage(info.file.response.mediaUrl);
                setDeleteOpen(true)
                message.success(`${info.file.name} File upload successful`);
            } else if (status === 'error') {
                message.error(`${info.file.name} File upload failed`);
            }
        },
        listType: 'picture',
        showUploadList: false,
    };
    const handleDeleteImage = () => {
        setImage(null);
        setDeleteOpen(false);
    };
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    const CreateTask = (id) => {
        setCreatePageTask("ListingLead")
        setNaCTrigger("trigger")
        setTaskProp({
            type: "Lead",
            ids: [id]
        })
    }
    const CreateMail = () => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            setNaCTrigger("trigger")
            setMailOpen(true)
        }
    }
    const CreateMeeting = (LId, firstname, lastname, mail) => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            setMeetingAttendees([{
                id: LId,
                name: `${firstname} ${lastname}`,
                type: "Leads",
                email: mail,
            }])
            setNaCTrigger("trigger")
            setMeetingOpen(true)
        }
    }
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    // const onSelect = (value) => {
    //     form.setFieldsValue({
    //         accountName: value
    //     })
    // };
    const handleEditChange = () => {
        if (approveCondition) {
            setApproveOpen(true)
        }
        else {
            setEditField(true)
            setEdit(true)
            dispatch(setEditCall(true))
            setTrigger("");
            setApproveOpen(false)
        }
    }
    const handleConvertChange = () => {
        if (approveCondition) {
            setApproveOpen(true)
        }
        else {
            ConvertApi(leadId)
            setApproveOpen(false)
        }
    }
    const handleMergeclick = () => {
        if (approveCondition) {
            setApproveOpen(true)
            setMergeOpen(false)
        }
        else {
            setNaCTrigger("trigger")
            setApproveOpen(false)
            setMergeOpen(true)
        }
    }
    const moreAction = "Yes"
    const MoreAction = ({ closeDropdown }) => (
        <div style={{
            padding: "0px",
            width: "100%",
            height: "100%",
        }}>
            <Link to={combinedUrl}
                onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { CloneLead(); closeDropdown() }}
                className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <CloneIcon height={15} width={15} marginRight={5} /> Clone
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canShare(dataPermissions, "Sharing")) ? undefined : () => { HandleShareClick(); closeDropdown() }} className={`text_icon ${(edit || !canShare(dataPermissions, "Sharing")) ? 'disabled_link' : ""}`}>
                <ShareIcon height={14} width={14} marginRight={5} /> Share
            </Link>
            <Link to={combinedUrl} onClick={(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? () => { AssignToFucntion(); closeDropdown() } : undefined} className={`text_icon ${(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? "" : 'disabled_link'}`}>
                <ChangeOwnerIcon height={15} width={15} marginRight={5} /> Change Owner
            </Link>
            <Link to={combinedUrl} onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { handleNoteClick("Create"); closeDropdown() }} className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <NotesIcon height={15} width={15} marginRight={5} /> Add a Note
            </Link>
            <Link to={combinedUrl} onClick={(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? () => { handleMergeclick(); closeDropdown() } : undefined} className={`text_icon ${(!edit && canUpdateDelete(permissions, dataPermissions, "Update", 2003)) ? "" : 'disabled_link'}`}>
                <MergeIcon height={15} width={15} marginRight={5} /> Merge Duplicates
            </Link>
            <Link to={combinedUrl}
                onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { HandleAddCampaignClick(); closeDropdown() }}
                className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <CampaignIcon height={15} width={15} marginRight={5} /> Add to Campaign
            </Link>
            {assignOwner === profile.userId ? <Link to={combinedUrl}
                onClick={(edit || !canCreate(permissions, 2002)) ? undefined : () => { HandleAddOutreachClick(); closeDropdown() }}
                className={`text_icon ${(edit || !canCreate(permissions, 2002)) ? "disabled_link" : ''}`}>
                <EmailseqQueueIcon height={15} width={15} marginRight={5} /> Add to Outreach Sequence
            </Link> : <></>}
        </div >
    );
    MoreAction.propTypes = {
        closeDropdown: PropTypes.func.isRequired,
    };
    const ButtonActions = [
        {
            Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Send Email'
                onClick={(!canCreate(permissions, 2002)) ? undefined : () => CreateMail()}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMail()
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Schedule a Meeting'
                onClick={(!canCreate(permissions, 2002)) ? undefined : () => CreateMeeting(leadId, displayData?.first_name, displayData?.last_name, displayData?.primary_email)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateMeeting(leadId, displayData?.first_name, displayData?.last_name, displayData?.primary_email)
                    }
                }}
                aria-label='meeting'
            > <CalendarIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Create Task'
                onClick={(!canCreate(permissions, 2002)) ? undefined : () => CreateTask(leadId)}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) {
                        CreateTask(leadId)
                    }
                }}
                aria-label='task'
            > <TaskIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className={(!canCreate(permissions, 2002)) ? "disabled-style" : 'Hover-Refresh2 back-hover1 able-style'}
                role="button"
                tabIndex={0} title='Log a Call'
                onClick={(!canCreate(permissions, 2002)) ? undefined : () => handleCallLogClick("Create")}
                onKeyDown={(event) => {
                    if (canCreate(permissions, 2002) && (event.key === 'Enter' || event.key === ' ')) {
                        handleCallLogClick("Create")
                    }
                }}
                aria-label='phone'
            > <CallLogIcon height={20} width={20} /></div>
        },
    ]
    const LeadInfos = {
        profile: image,
        Classname: "LeadIcon",
        letterIcon: displayData?.first_name,
        name: `${displayData?.title ? displayData?.title : ""} ${displayData?.first_name} ${displayData?.last_name}`,
        subName: (displayData?.designation !== "" && displayData?.designation !== null && displayData?.designation !== "Not Applicable")
            ? (profile.dateFormate ? moment(displayData?.designation).format(profile.dateFormate) :
                (displayData?.designation && moment(displayData?.designation).format("YYYY-MM-DD"))) : "Date of Birth",
        mainAction: <>
            <Button className="button_colors" size="small" style={{ width: "80%" }} onClick={canUpdateDelete(permissions, dataPermissions, "Update", 2003) ? () => handleConvertChange() : undefined} disabled={!canUpdateDelete(permissions, dataPermissions, "Update", 2003)}>
                <ConvertIcon height={25} width={25} /> Convert to Resident
            </Button>
        </>,
    }
    const EditOpenForDrawer = () => {
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const { firstName, annualrevenue, noofemployees, linkedinUrl, websiteName, seniorityLevel, industry, rating, description, lastName, postcode, street, accountName, leadOwner, title, primaryEmail, phone, fax, mobile, leadSource, leadStatus, secondaryEmail } = values;
        const payload =
        {
            seniorityLevelId: normalizeValue(seniorityLevel),
            firstName: normalizeValue(firstName),
            lastName: normalizeValue(lastName),
            leadOwner: normalizeValue(leadOwner),
            designation: normalizeValue(expectedClosureDate),
            accountName: normalizeValue(accountName),
            industry: normalizeValue(industry),
            rating: normalizeValue(rating),
            nomOfEmployees: normalizeValue(noofemployees),
            title: normalizeValue(title),
            primaryEmail: normalizeValue(primaryEmail),
            secondaryEmail: normalizeValue(secondaryEmail),
            phone: normalizeValue(phone),
            mobile: normalizeValue(mobile),
            leadSourceId: normalizeValue(leadSource),
            leadStatusId: normalizeValue(leadStatus),
            emailOptOut: normalizeValue(checked),
            fax: normalizeValue(fax),
            description: normalizeValue(description),
            leadProfile: normalizeValue(image),
            leadFiles: FILEList,
            city: normalizeValue(city),
            street: normalizeValue(street),
            country: normalizeValue(country),
            postcode: normalizeValue((postcode && postcode !== "") ? Number(postcode) : undefined),
            state: normalizeValue(state),
            annualRevenue: normalizeValue(annualrevenue),
            website: normalizeValue(websiteName),
            linkedinUrl: normalizeValue(linkedinUrl),
            relatedLeadId: normalizeValue(relatedLead)
        }
        const updatedFields = getChangedFields(payload, leadInitial);
        if (Object.keys(updatedFields).length === 0) {
            getData(leadId)
            scroolup()
            message.success("Lead updated")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
            return;
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
                const response = await LeadUpdate(updatedFields, leadId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const isAutomation = response.data[0].message === AutomationMessage;
                        const isApproval = response.data[0].message === ApprovalMessage;
                        const ownerChanged = displayData?.lead_owner !== leadOwner;
                        if (isApproval) {
                            hideMessage();
                            getData(leadId)
                            scroolup()
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                            loadingRef.current = false;
                            setDoubleClick(false)
                            CloseDrawerNew()
                        }
                        else if (ownerChanged) {
                            hideMessage();
                            if (isAutomation) {
                                successMessage("Automation rule triggered", response.data[0].message);
                            } else {
                                message.success(
                                    <span>
                                        Lead <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                    </span>
                                );
                            }
                            dispatch(setEditCall(false));
                            history.push('/Home/candidates');
                        }
                        else {
                            getData1(leadId, hideMessage, isAutomation, response)
                            scroolup();
                        }
                    }
                }
            }
            else {
                const response = await LeadSave(updatedFields)
                if (response.status === 201) {
                    const isAutomation = response?.data === AutomationMessage;
                    const isApproval = response?.data === ApprovalMessage;
                    hideMessage();
                    if (isApproval) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    } else if (isAutomation) {
                        successMessage("Automation rule triggered", response?.data);
                    } else {
                        message.success(response?.data);
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer();
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error)
        }
    }
    const onSubmitClone = (value) => {
        if (displayData.account_name !== value.accountName) {
            Modal.confirm({
                icon: null,
                className: "customice-confirm-modal",
                title: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                        <span>Account Changed</span>
                    </div>
                ),
                content: (
                    <div>
                        <p>You are modifying the account name for this lead only. If other leads use the same account, their account names must be updated manually.</p>
                    </div>
                ),
                centered: true,
                okText: "Continue",
                cancelText: "Cancel",
                okButtonProps: {
                    className: "button_colorsModal"
                },
                cancelButtonProps: {
                    className: "gray-buttonModal"
                },
                // okCancel: true,
                onOk() {
                    onSubmit(value);
                },
                onCancel() {
                    scroolup()
                    getData(leadId)
                },
            });
        } else {
            onSubmit(value);
        }
    }
    const CloseDrawer2 = () => {
        scroolup();
        getData(leadId)
        setEditField(false)
        setEdit(false);
        dispatch(setEditCall(false))
        setDrawerPage()
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            CloseDrawer2()
        }
        else if (FromPage === "EntityUpdate" && drawerPage === "CloneLead") {
            setCancelConfirmOpen(true)
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const getRefreshtheTable = () => {
        CloseDrawer2()
        setTrigger("activity")
    }
    useEffect(() => {
        if (account.length && displayData?.account_name) {
            const matched = account.find(acc => acc.value === displayData.account_name);
            if (matched) {
                setDataDisables({
                    isDisable: matched.data.status === "Qualified",
                    allow: matched.data.status === "Qualified",
                    id: matched.data.accountID,
                    profile: matched.data.accountProfile
                });
            } else {
                setDataDisables({
                    isDisable: false,
                    allow: false,
                    id: null,
                    profile: null
                })
            }
        }
    }, [displayData, account]);
    const normalizeValue2 = (value) => value?.toLowerCase()?.trim() || '';
    const getSeniorityLevelId = (senioritys) => {
        const normalized = normalizeValue2(senioritys);
        const match = seniority.find(item =>
            item.seniorityLevel.toLowerCase().includes(normalized)
        );
        return match || null;
        // return match?.seniorityLevelId || null;
    };
    const attributes = [
        { key: "first_name", label: "First Name" },
        { key: "last_name", label: "Last Name" },
        { key: "primary_email", label: "Primary Email" },
        { key: "designation", label: "Designation" },
        { key: "seniority_level", label: "Seniority Level" },
        { key: "linkedin_url", label: "Linkedin Url" },
        { key: "country", label: "Country" },
        { key: "state", label: "State" },
        { key: "city", label: "City" },
    ];
    const updateEnrichdata = async (value) => {
        form.setFieldsValue({
            firstName: value.first_name,
            lastName: value.last_name,
            primaryEmail: value.primary_email,
            designation: value.designation,
            seniorityLevel: value.seniority_level_id,
            country: value.country,
            linkedinUrl: value.linkedin_url,
        })
        setCountry(value.country)
        try {
            const response = await getCountryData()
            if (value.country) {
                const countryInfo = response.find(countrys => countrys.country === value.country);
                if (countryInfo) {
                    const iso = countryInfo.countryId
                    getState(value, iso)
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    const showConfirm2 = (newStructure) => {
        const tableData = attributes.map((attr, index) => ({
            key: index,
            attribute: attr.label,
            oldValue: displayData?.[attr.key] ?? "-",
            enrichedValue: newStructure?.[attr.key] ?? "-",
        }));
        const columnss = [
            {
                title: "Attribute",
                dataIndex: "attribute",
                key: "attribute",
                width: "30%",
                ellipsis: true,
                render: (text) => (
                    <Typography.Paragraph
                        ellipsis={{ tooltip: text }}
                        style={{ marginBottom: 0 }}
                    >
                        {text}
                    </Typography.Paragraph>
                ),
            },
            {
                title: "Lead Data",
                dataIndex: "oldValue",
                key: "oldValue",
                width: "35%",
                ellipsis: true,
                render: (text) => (
                    <Typography.Paragraph
                        ellipsis={{ tooltip: text }}
                        style={{ marginBottom: 0 }}
                    >
                        {text}
                    </Typography.Paragraph>
                ),
            },
            {
                title: "Enriched Data",
                dataIndex: "enrichedValue",
                key: "enrichedValue",
                width: "35%",
                ellipsis: true,
                render: (text) => (
                    <Typography.Paragraph
                        ellipsis={{ tooltip: text }}
                        style={{ marginBottom: 0 }}
                    >
                        {text}
                    </Typography.Paragraph>
                ),
            },
        ];
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span>Lead Enrichment</span>
                </div>
            ),
            icon: null,
            width: 1000,
            content: (
                <div>
                    <p>Are you sure, you want to add enriched data?</p>
                    <div className="table-bordered leaderboard-table table-responsive">
                        <Table
                            dataSource={tableData}
                            columns={columnss}
                            rowKey={(record, index) => index?.toString()}
                            pagination={false}
                            tableLayout="fixed"
                        />
                    </div>
                </div>
            ),
            className: "customice-confirm-modal",
            centered: true,
            okText: "Enrich",
            cancelText: "Cancel",
            okButtonProps: {
                className: "button_colorsModal"
            },
            cancelButtonProps: {
                className: "gray-buttonModal"
            },
            okCancel: true,
            onOk() {
                updateEnrichdata(newStructure)
            },
            onCancel() {
                modal.destroy();
            },
        });
    };
    async function ConnectwithLead(paramsEmail) {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Collecting lead information...", 0);
            const response = await hunterioLeadDetails(profile.companyId, paramsEmail)
            const LeadData = response.data
            const seniorityLevel = getSeniorityLevelId(LeadData?.employment?.seniority);
            const newStructure = {
                "first_name": LeadData?.name?.givenName ? LeadData?.name?.givenName : displayData?.first_name,
                "last_name": LeadData?.name?.familyName ? LeadData?.name?.familyName : displayData?.last_name,
                "primary_email": LeadData?.email ? LeadData?.email : displayData?.primary_email,
                "designation": LeadData?.employment?.title ? LeadData?.employment?.title : displayData?.designation,
                "seniority_level_id": seniorityLevel?.seniorityLevelId ? seniorityLevel?.seniorityLevelId : displayData?.seniority_level_id,
                "seniority_level": seniorityLevel?.seniorityLevel ? seniorityLevel?.seniorityLevel : displayData?.seniority_level,
                "linkedin_url": LeadData?.linkedin?.handle ? `https://www.linkedin.com/in/${LeadData?.linkedin?.handle}` : null,
                "country": LeadData?.geo?.country ? LeadData?.geo?.country : displayData?.country,
                "state": LeadData?.geo?.state ? LeadData?.geo?.state : null,
                "city": LeadData?.geo?.city ? LeadData?.geo?.city : null
            }
            message.success("Lead enriched successful")
            loadingRef.current = false;
            setDoubleClick(false)
            hideMessage();
            showConfirm2(newStructure)
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error)
        }
    }
    const handleFinish = (values) => {
        if (FromPage === "EntityUpdate" && drawerPage !== "CloneLead") {
            onSubmitClone(values);
        } else {
            onSubmit(values);
        }
    };
    const memoUrlId = useMemo(() => (UrlId ? [UrlId[0], leadId] : null), [UrlId, leadId]);
    const updatePsqq = useMemo(() => ({
        permission: permissions,
        dataPermission: dataPermissions,
        type: "Update",
        PId: 2003,
    }), [permissions, dataPermissions]);
    const getDetailsDatas = useCallback(() => getData(leadId), [leadId]);
    const MemoLeadStatusBar = useMemo(() => (
        <LeadStatusBar UrlId={memoUrlId} getDetailsData={getDetailsDatas} leadStatusData={leadStatusData} displayData={displayData} setNaCTrigger={setNaCTrigger} canUpdateDelete={canUpdateDelete}
            UpdatePs={updatePsqq} successMessage={successMessage} ApprovalMessage={ApprovalMessage} AutomationMessage={AutomationMessage}
            setErrorData={setErrorData} setIsModalVisible1={setIsModalVisible1} setTrigger={setTrigger} />
    ), [
        memoUrlId,
        getDetailsDatas,
        leadStatusData,
        displayData,
        setNaCTrigger,
        canUpdateDelete,
        updatePsqq,
        successMessage,
        ApprovalMessage,
        AutomationMessage,
        setErrorData,
        setIsModalVisible1,
        setTrigger
    ]);
    const MemoLeadFields = useMemo(() => (
        <LeadFields displayData={displayData} setNaCTrigger={setNaCTrigger} />
    ), [displayData, setNaCTrigger]);
    const MemoRelatedTab = useMemo(() => (
        <RelatedTab EntityType="Lead" UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailapiValues} trigger={trigger} />
    ), [memoUrlId, NacTrigger, setNaCTrigger, profile, emailapiValues, trigger]);
    const MemoRightRelatedData = useMemo(() => (
        <LeadRightData displayData={displayData} dataDisables={dataDisables} profile={profile} ViewDetailPage={ViewDetailPage} Role={Role} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} trigger={trigger} />
    ), [displayData, dataDisables, profile, ViewDetailPage, Role, memoUrlId, NacTrigger, setNaCTrigger, trigger]);
    const RequiredDateFormating = (dateString) => {
        const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
        const formattedDate = parsedDate.format("YYYY-MM-DD");
        return formattedDate;
    }
    const expectedClosureDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setExpectedClosureDate(formattedDate);
        form.setFieldsValue({ designation: date });
    };
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel}
                                handleEditChange={handleEditChange}
                                canUpdateDelete={canUpdateDelete} entity="Lead"
                                UpdatePs={{ permission: permissions, dataPermission: dataPermissions, type: "Update", PId: 2003 }}
                                moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />}
                                ButtonActions={ButtonActions}
                                Maincontent={LeadInfos}
                                UpdateDataPage={MemoLeadStatusBar}
                                EntityTabDetails={MemoLeadFields}
                                EntityRelatedTab={MemoRelatedTab}
                                RightRelatedDetails={MemoRightRelatedData}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        drawerPage === "CloneLead" ? "Clone Candidate" :
                            <span>
                                Update Candidate
                                {(displayData?.first_name || displayData?.last_name) && (
                                    <>
                                        <span style={{
                                            margin: '0 10px',
                                            color: '#d9d9d9',
                                            fontWeight: 'normal'
                                        }}>|</span>
                                        <span style={{ fontWeight: 'normal' }}>
                                            {`${displayData?.first_name || ''} ${displayData?.last_name || ''}`.trim()}
                                        </span>
                                    </>
                                )}
                            </span>
                        : "Create Candidate"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        {!edit ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => EditOpenForDrawer()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        EditOpenForDrawer()
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={
                    (edit && uiReady) ? [
                        <div className="form_action_button">
                            <Button
                                className="gray-button" size="small"
                                onClick={() => PageCancel1()}
                            >
                                <CancelIcon height={25} width={25} />Cancel
                            </Button>
                            {FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ?
                                <Button disabled={!canUpdateDelete(permissions, dataPermissions, "Delete", 2004) || deleteClick || doubleClick}
                                    className="red-button" size="small" loading={deleteClick} onClick={() => deleteMenu(leadId)}
                                >
                                    {!deleteClick && <DeleteIcon height={25} width={25} />}Delete
                                </Button> : <></>}
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} loading={doubleClick} disabled={deleteClick || doubleClick}>
                                {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" && drawerPage !== "CloneLead" ? "Update" : "Save"}
                            </Button>
                        </div>] : false
                }
            >
                {(displayData && uiReady) ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={handleFinish} onFinishFailed={onFinishFailed} colon={false}>
                                <BasicFormWrapper>
                                    <div className="add-product-block">
                                        <div style={{ margin: 40 }}>
                                            <Row gutter={15}>
                                                <Col xs={24}>
                                                    <div className="add-product-content">
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                            <Heading as="h5">Basic Information</Heading>
                                                            {(FromPage === "EntityUpdate" && drawerPage !== "CloneLead") ?
                                                                <div role="button" className="Hover-Refresh2 back-hover1 able-style"
                                                                    tabIndex={0}
                                                                    onClick={edit ? () => ConnectwithLead(displayData?.primary_email) : undefined}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                            ConnectwithLead(displayData?.primary_email)
                                                                        }
                                                                    }}>
                                                                    <QUSOINIcon height={16} width={16} marginRight={5} />Enrich Lead
                                                                </div> : <></>
                                                            }
                                                        </div>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            {/* <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Title" name="title" id="title" >
                                                                    <Select style={{ width: '100%' }} placeholder="Select Title" allowClear onChange={(value) => form.setFieldsValue({ title: value || null })}>
                                                                        {title}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col> */}
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="First Name" name="firstName" id="firstName"
                                                                    rules={[{ required: true, message: 'Please enter first name' }, {
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 25);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <Input placeholder="Enter First Name" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Last Name" name="lastName" id="lastName"
                                                                    rules={[{ required: true, message: 'Please enter last name' }, {
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 25);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <Input placeholder="Enter Last Name" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Date of Birth" name="designation"
                                                                    id="designation"
                                                                    rules={[
                                                                        { required: true, message: 'Please select date of birth' },
                                                                        // {
                                                                        //     validator: (_, value) => {
                                                                        //         const error = validateTextField(value, 50);
                                                                        //         if (error) {
                                                                        //             return Promise.reject(new Error(error));
                                                                        //         }
                                                                        //         return Promise.resolve();
                                                                        //     },
                                                                        // }
                                                                    ]}>
                                                                    <DatePicker
                                                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                        value={expectedClosureDate ? moment(expectedClosureDate, "YYYY-MM-DD") : null}
                                                                        onChange={expectedClosureDateChange}
                                                                        disabledDate={(current) => {
                                                                            return current && current > moment().endOf("day");
                                                                        }}
                                                                    />
                                                                </Form.Item>
                                                            </Col>
                                                            {/* <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Seniority Level" name="seniorityLevel"
                                                                    id="seniorityLevel"
                                                                // rules={[{ required: true, message: 'Please select a seniority level' }]}
                                                                >
                                                                    <Select style={{ width: '100%' }} placeholder="Select Seniority Level"
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }>
                                                                        {seniority.map((option, i) => (
                                                                            <Option value={option.seniorityLevelId} key={i}>
                                                                                {option.seniorityLevel}
                                                                            </Option>))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col> */}
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Email Address" name="primaryEmail"
                                                                    id="primaryEmail" rules={[{ required: true, message: 'Please enter email address' },
                                                                    {
                                                                        validator: (_, value) => {
                                                                            const error = validateEmailField(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]} >
                                                                    <Input placeholder="Enter Email Address" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Name and Relationship (next of Kin)" name="secondaryEmail"
                                                                    id="secondaryEmail"
                                                                // rules={[{
                                                                //     validator: (_, value) => {
                                                                //         const error = validateEmailField(value, 50);
                                                                //         if (error) {
                                                                //             return Promise.reject(new Error(error));
                                                                //         }
                                                                //         return Promise.resolve();
                                                                //     },
                                                                // }]} 
                                                                >
                                                                    <Input placeholder="Enter Name and Relationship (next of Kin)" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Phone Number (Next of Kin)" name="phone"
                                                                    id="phone" rules={[
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = mobileOnChangeValidator(value, 20);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]}>
                                                                    <Input placeholder="Enter Phone Number" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="NHS Number" name="fax"
                                                                    id="fax" rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = mobileOnChangeValidator(value, 20);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }>
                                                                    <Input placeholder="Enter NHS Number" />
                                                                </Form.Item>
                                                            </Col>
                                                            {/* <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Mobile" name="mobile"
                                                                    id="mobile" rules={
                                                                        [
                                                                            {
                                                                                validator: (_, value) => {
                                                                                    const error = mobileOnChangeValidator(value, 20);
                                                                                    if (error) {
                                                                                        return Promise.reject(new Error(error));
                                                                                    }
                                                                                    return Promise.resolve();
                                                                                },
                                                                            },
                                                                        ]
                                                                    }>
                                                                    <Input placeholder="Enter Mobile Number" />
                                                                </Form.Item>
                                                            </Col> */}
                                                            {/* <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Linkedin Url" name="linkedinUrl" id="linkedinUrl"
                                                                // rules={
                                                                //     [
                                                                //         {
                                                                //             validator: (_, value) => {
                                                                //                 const error = validateUrlField(value, 2000);
                                                                //                 if (error) {
                                                                //                     return Promise.reject(new Error(error));
                                                                //                 }
                                                                //                 return Promise.resolve();
                                                                //             },
                                                                //         },
                                                                //     ]
                                                                // }
                                                                >
                                                                    <Input placeholder="Enter Linkedin Url" />
                                                                </Form.Item>
                                                            </Col> */}
                                                        </Row>
                                                        <Heading as="h5">Candidate Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Candidate Owner" name="leadOwner"
                                                                    id="leadOwner"
                                                                    rules={[{ required: true, message: 'Please select a candidate owner', }]}>
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Candidate Owner"
                                                                        showSearch
                                                                        optionLabelProp="label"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }>
                                                                        {users}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Candidate Source" name="leadSource"
                                                                    id="leadSource" rules={[{ required: true, message: 'Please select a candidate source', }]}>
                                                                    <Select style={{ width: '100%' }} placeholder="Select Candidate Source"
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }>
                                                                        {leadsource}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Candidate Status" name="leadStatus"
                                                                    id="leadStatus" rules={[{ required: true, message: 'Please select a candidate status', }]}>
                                                                    <Select style={{ width: '100%' }} placeholder="Select candidate Status"
                                                                        showSearch
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }>
                                                                        {leadStatus}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            {/* <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Email Opt Out?">
                                                                    <Checkbox
                                                                        checked={checked}
                                                                        onChange={(e) =>
                                                                            handleChange(
                                                                                e.target.checked
                                                                            )
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </Col> */}
                                                        </Row>
                                                        <Row gutter={30} style={{ marginBottom: 20 }}>
                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Primary Diagnosis / Reason for Referral" name="description" id="description" rules={
                                                                    [
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateDescriptionField(value, 2500);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]
                                                                }>
                                                                    <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Primary Diagnosis / Reason for Referral' />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row >
                                                        <Heading as="h5">Sponsor Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Sponsor Name" name="accountName" id="accountName"
                                                                    rules={[{ required: true, message: 'Please enter sponsor name' }, {
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}>
                                                                    <AutoComplete
                                                                        options={account.map(acc => ({
                                                                            value: acc.value, key: acc.key, data: acc.data, label: (
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                    <span>{acc.value}</span>
                                                                                    <span>
                                                                                        ({acc.data.status})
                                                                                    </span>
                                                                                </div>
                                                                            ),
                                                                        }))}
                                                                        onSelect={(value, option) => {
                                                                            form.setFieldsValue({
                                                                                accountName: value,
                                                                                industry: option.data.industry,
                                                                                rating: option.data.rating,
                                                                                noofemployees: option.data.employee,
                                                                                annualrevenue: option.data.revenue,
                                                                                websiteName: option.data.website,
                                                                            });
                                                                            setRelatedLead(option.data.leadId)
                                                                            setDataDisables(
                                                                                {
                                                                                    isDisable: option.data.status === "Qualified",
                                                                                    allow: option.data.status === "Qualified",
                                                                                    id: option.data.accountID,
                                                                                    profile: option.data.accountProfile
                                                                                }
                                                                            )
                                                                        }}
                                                                        onChange={(inputValue) => {
                                                                            const match = account.find(acc => acc.value === inputValue);
                                                                            if (!match) {
                                                                                form.setFieldsValue({
                                                                                    industry: undefined,
                                                                                    rating: undefined,
                                                                                    noofemployees: undefined,
                                                                                    annualrevenue: undefined,
                                                                                    websiteName: undefined,
                                                                                });
                                                                                setDataDisables({
                                                                                    isDisable: false,
                                                                                    allow: false,
                                                                                    id: null,
                                                                                    profile: null
                                                                                });
                                                                                setRelatedLead(null)
                                                                            }
                                                                        }}
                                                                        // options={account}
                                                                        // onSelect={onSelect}
                                                                        style={{ width: '100%' }}
                                                                        placeholder="Type or select an sponsor"
                                                                        filterOption={(inputValue, option) =>
                                                                            option.value.toLowerCase().includes(inputValue.toLowerCase())
                                                                        }
                                                                    >
                                                                        <Input />
                                                                    </AutoComplete>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Sponsor Url" name="websiteName" id="websiteName" rules={
                                                                    [dataDisables?.isDisable ? { required: false } : { required: true, message: 'Please enter sponsor url' },
                                                                    {
                                                                        validator: (_, value) => {
                                                                            const error = validateUrlField(value, 2000);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    },
                                                                    ]
                                                                }>
                                                                    <Input placeholder="Enter Sponsor Url" disabled={dataDisables?.isDisable} />
                                                                </Form.Item>
                                                            </Col>
                                                            {/* <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Industry" name="industry"
                                                                    id="industry" rules={[dataDisables?.isDisable ? { required: false } : { required: true, message: 'Please enter industry' }]}>
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Industry"
                                                                        showSearch disabled={dataDisables?.isDisable}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {industryData.map((option, i) => (
                                                                            <Option value={option.industryId} key={i}>
                                                                                {option.industryName}
                                                                            </Option>))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col> */}
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                {/* <Form.Item label="Rating" name="rating"
                                                                    id="rating" >
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Rating" disabled={dataDisables?.isDisable}
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ rating: value || null })}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {rating}
                                                                    </Select> */}
                                                                <Form.Item label="Referrer Name & Role" name="rating"
                                                                    id="rating">
                                                                    <Input placeholder="Enter Referrer Name & Role" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Referral Source" name="noofemployees"
                                                                    id="noofemployees" >
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Referral Source" disabled={dataDisables?.isDisable}
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ noofemployees: value || null })}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        <Option value="NHS / ICB">NHS / ICB</Option>
                                                                        <Option value="Local Authority">Local Authority</Option>
                                                                        <Option value="Community Mental Health Team">Community Mental Health Team</Option>
                                                                        <Option value="Hospital / Secure Unit">Hospital / Secure Unit</Option>
                                                                        <Option value="GP">GP</Option>
                                                                        <Option value="Social Worker">Social Worker</Option>
                                                                        <Option value="Self-Referral">Self-Referral</Option>
                                                                        <Option value="Other">Other</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            {/* <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Annual Revenue (USD)" name="annualrevenue"
                                                                    id="annualrevenue" >
                                                                    <Select style={{ width: '100%' }}
                                                                        placeholder="Select Annual Revenue" disabled={dataDisables?.isDisable}
                                                                        showSearch allowClear onChange={(value) => form.setFieldsValue({ annualrevenue: value || null })}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                    >
                                                                        {revenue}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col> */}
                                                        </Row>
                                                        <Heading as="h5">Address Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Country" name="country" id="country" rules={[{ message: 'Please select country', required: true }]} >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        placeholder="Select Country"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleCountryChange}
                                                                        value={country}
                                                                    >
                                                                        {allCountry?.map((option) => (
                                                                            <Option key={option.countryId} value={option.country}>
                                                                                {option.country}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="State" >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        placeholder="Select State"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleStateChange}
                                                                        value={state}
                                                                    >
                                                                        {allState?.map((option) => (
                                                                            <Option key={option.stateId} value={option.state}>
                                                                                {option.state}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="City" >
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        placeholder="Select City"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleCityChange}
                                                                        value={city}
                                                                    >
                                                                        {allCity?.map((option) => (
                                                                            <Option key={option.cityId} value={option.city}>
                                                                                {option.city}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Street" name="street" id="street" rules={[{
                                                                    validator: (_, value) => {
                                                                        const error = validateAddressLine(value, 100);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter Street" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Zip Code" id="postcode" name="postcode" rules={[{
                                                                    validator: (_, value) => {
                                                                        const error = validateZipCode(value, 25);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                                    <Input placeholder="Enter Zip Code" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row >
                                                        <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                        <Heading as="h5">Profile Picture</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <figure className="photoUpload align-center-v" >
                                                                    {image !== null && image !== undefined && image !== "" ?
                                                                        < img src={image} alt="" />
                                                                        :
                                                                        UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD" ?
                                                                            <span className='details_span_Tag LeadIcon'>
                                                                                {displayData?.first_name?.slice(0, 1).toUpperCase()}
                                                                            </span>
                                                                            :
                                                                            <span className='details_span_Tag LeadIcon'>
                                                                                C
                                                                            </span>}
                                                                    {edit &&
                                                                        <figcaption>
                                                                            {deleteOption ? (
                                                                                <div className='delete-div'>
                                                                                    <span className='delete-span'>
                                                                                        <FeatherIcon icon="trash-2" className="icon-svg" size={16} onClick={handleDeleteImage} />
                                                                                    </span>
                                                                                </div>) :
                                                                                (<div>
                                                                                    <ImgCrop aspect={1} cropShape="round" rotationSlider modalTitle="Crop Image">
                                                                                        <Upload {...FileUpload}>
                                                                                            <Link className="btn-upload" to={combinedUrl}>
                                                                                                <FeatherIcon icon="camera" size={16} />
                                                                                            </Link>
                                                                                        </Upload>
                                                                                    </ImgCrop>
                                                                                </div>)
                                                                            }
                                                                        </figcaption>
                                                                    }
                                                                </figure>
                                                            </Col>
                                                        </Row>
                                                        {(UrlId !== undefined && UrlId !== null && UrlId[0] === "?LEAD" && drawerPage !== "CloneLead") && <>
                                                            <Heading as="h5">Other Information</Heading>
                                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Created Date" >
                                                                        <span >{displayData?.created_at}</span>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Created By" >
                                                                        <UploadUserTag record={{
                                                                            uploadedBy: `${displayData?.createdByFirstName} ${displayData?.createdByLastName}`,
                                                                            uploadedById: displayData?.created_by,
                                                                            uploadedProfile: displayData?.createdByProfilePic
                                                                        }} />
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Modified Date" >
                                                                        <span >{displayData?.modified_at}</span>
                                                                    </Form.Item>
                                                                </Col>
                                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Modified By" >
                                                                        <UploadUserTag record={{
                                                                            uploadedBy: `${displayData?.modifiedByFirstName} ${displayData?.modifiedByLastName}`,
                                                                            uploadedById: displayData?.modified_by,
                                                                            uploadedProfile: displayData?.modifiedByProfilePic
                                                                        }} />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row >
                                                        </>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars>
                    :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer>
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Lead" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            <AddTaskPage UrlId={undefined} FromPage={createPageTask} setCratePage={setCreatePageTask} CallBackTrigger={setNaCTrigger} fromPageforTask="FromDetails" taskProp={taskProp} />
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="Leads" entity="EntityPages" toId={[{ id: displayData?.leads_id, type: "Leads" }]} CallBackTrigger={setNaCTrigger} />
            {approveOpen && <Approvaldialog confirmPopup={approveOpen} setConfirmPopup={setApproveOpen} />}
            {campaignPopup && <AddtoCampaignPopup sharePopup={campaignPopup} setSharePopup={setCampaignPopup} sharingType="Lead" sharingIds={[leadId]} PageTypes="Single" />}
            {outreachPopup && <AddtoOutreachPopup sharePopup={outreachPopup} setSharePopup={setOutreachPopup} sharingType="Lead" sharingIds={leadId} PageTypes="Single" />}
            {sharePopup && <SharePopup sharePopup={sharePopup} setSharePopup={setSharePopup} sharingType="Lead" sharingIds={[leadId]} PageTypes="Single" />}
            {popup && <ConvertPopup popup={popup} setPopup={setPopup} GetAll={getDetailsDatas} popupType={popupType} values={values} action={action} assignOwner={assignOwner} successMessage={successMessage} setDoubleClick={setDelteClick} loadingRef={loadingRef} deleteClick={deleteClick} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} page={page} />}
            {callLogPopup && <CallLogPopup setCallLogPopup={setCallLogPopup} callLogPopup={callLogPopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} />}
            <MeetingLiPopup meetingOpen={meetingOpen} setMeetingOpen={setMeetingOpen} GetAll={getDetailsDatas} taskPage={taskPage} setNaCTrigger={setNaCTrigger} popupPageType="Create" meetingDate={formattedDate} meetingTime={formattedTime} Attendees={meetingAttendees} />
            <MergePage meetingOpen={mergeOpen} deletecheck={!hasRoleDeletePermission(permissions, 2004)} setMeetingOpen={setMergeOpen} GetAll={getDetailsDatas} pageIdentifier="Leads" setNaCTrigger={setNaCTrigger} PryData={displayData} />
        </>
    );
}
AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    ShortCut: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
};

export default AddNew;